import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";

import { ListItem, ListItemButton } from "@mui/material";

import SFTypography from "../typography";

const { styled } = getStyled();

const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: theme.palette.blue50.main,
  },
}));

const LoadMoreButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <ListItem disablePadding>
      <ListItemButtonStyled disableRipple onClick={onClick}>
        <SFTypography variant="body1">
          {t("components.typeahead.loadMore")}
        </SFTypography>
      </ListItemButtonStyled>
    </ListItem>
  );
};

LoadMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LoadMoreButton;
